import request from '../utils/request'

/**
 * 登录或者注册
 * @param {Object} data
 */
export function login (data) {
  return request({
    url: '/users/phone/login_or_register',
    method: 'post',
    data
  })
}

/**
 * 微信登录强制绑定手机号
 * @param {Object} data
 */
export function bindPhone (data) {
  return request({
    url: '/users/phone/bind',
    method: 'post',
    data
  })
}

/**
 * 微信账户是否绑定了手机号
 */
export function isWxBindPhone () {
  return request({
    url: '/users/mp_wechat/is_bind_phone',
    method: 'post'
  })
}

/**
 * 根据手机号获取手机验证码
 * @param {Object} data
 */
export function phoneApplyCode (data) {
  return request({
    url: '/users/phone/apply_code',
    method: 'post',
    data
  })
}

/**
 * 根据手机号判断用户是否注册
 * @param {Object} data
 */
export function registedOrNot (data) {
  return request({
    url: '/users/phone/registed_or_not',
    method: 'post',
    data
  })
}

/**
 * 微信登录
 * @param {Object} data.
 */
export function wechatLogin (data) {
  return request({
    url: '/users/mp_wechat/login',
    method: 'post',
    data
  })
}

/**
 * 微信登录
 * @param {Object} data.
 */
export function wechatLoginPhoneOnly (data) {
  return request({
    url: '/users/mp_wechat/login_v2',
    method: 'post',
    data
  })
}

/**
 * 获取微信openid
 * @param {Object} data.
 */
export function getWechatOpenID (data) {
  return request({
    url: '/users/mp_wechat/get_mp_openid',
    method: 'post',
    data
  })
}

/**
 * 根据token获取用户信息
 * @param {Object} data
 * @return vip_type
 */
export function getUserInfo (token) {
  return request({
    url: '/users/get_user_info',
    method: 'post',
    token
  })
}

/**
 * 刷新token
 * @param {Object} data
 */
export function refreshToken (data) {
  return request({
    url: '/users/refresh_token',
    method: 'post',
    data
  })
}

/**
 * 退出登录
 */
export function logout () {
  return request({
    url: '/users/logout',
    method: 'post'
  })
}

/**
 * 用户反馈
 * @param {Object} data
 */
export function userFeedback (data) {
  return request({
    url: '/users/feedback',
    method: 'post',
    data
  })
}

/**
 * 我的钱包
 * @param token
 * @return {integer} balance, withdrawal
 */
export function userWalletInfo () {
  return request({
    url: '/users/wallet_info',
    method: 'post'
  })
}

/**
 * (余额明细)提现列表
 * @param token
 * @return {object} withdrawal_money, update_time, withdrawal_to_account
 */
export function userWithdrawalList (data) {
  return request({
    url: '/users/withdrawal/list',
    method: 'post',
    data
  })
}

/**
 * (余额明细)消费返佣奖励详情
 * @param page size
 * @return {object} goods_name, update_time, consume_reward_money, user_name
 */
export function userConsumeRewardList (data) {
  return request({
    url: '/users/consume_reward/list',
    method: 'post',
    data
  })
}

/**
 * 余额-用户余额支付消费
 * @param page size
 * @return {object}
 */
export function userConsumeList (data) {
  return request({
    url: '/users/wallet/consume/list',
    method: 'post',
    data
  })
}

/**
 * 用户可用配音
 * @param page size
 * @return {object}
 */
export function remainingAvailableDubbings () {
  return request({
    url: '/users/remaining_available_dubbings',
    method: 'post'
  })
}

/**
 * 配音条数充值/消耗详情
 * @param page size
 * @return {object}
 */
export function topupOrConsumeDetailsList (data) {
  return request({
    url: '/users/topup_or_consume_details_list/v2',
    method: 'post',
    data
  })
}

/**
 * 获取小程序码
 * @param token
 * @return content_type, buffer
 */
export function userGetMiniprogramCode () {
  return request({
    url: '/users/get_miniprogram_code',
    method: 'post'
  })
}

/**
 * 活动-获取被邀请人列表
 * @param page size
 * @return {object} avatar, nick_name, update_time, reward_money
 */
export function userInviteeList (data) {
  return request({
    url: '/users/invitee/list',
    method: 'post',
    data
  })
}

/**
 * 活动-分享H5汇总接口
 * @param page size
 * @return {object}
 */
export function userActivityShareInfo () {
  return request({
    url: '/users/activity_share_info',
    method: 'post'
  })
}

/**
 * 活动-分享H5分销等级
 * @param page size
 * @return {object}
 */
export function userDistributionList () {
  return request({
    url: '/users/distribution/list',
    method: 'post'
  })
}

/**
 * 余额提现
 * @param page size
 * @return {object}
 */
export function userWithdrawalMoney () {
  return request({
    url: '/users/withdrawal_money',
    method: 'post'
  })
}
